import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'

let projectName = 'formulario-de-cadastro'

const routes: Routes = [ 
  { path: '', loadChildren: () => import('projects/' + projectName + '/src').then(m => m.AppModule) }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
